import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

const Logo = ({ width, height, routeParams }) => (
  <div className="reds-light-logo-container">
    <Link to={`/${routeParams?.location}/`}>
      <StaticImage
        style={{ width: width, height: height }}
        src="../static/images/icon/redsoda-logo-light.svg"
        alt="icon/redsoda-logo-light"
        formats={["auto", "webp", "avif"]}
      />
    </Link>
  </div>
)

Logo.defaultProps = {
  width: ``,
  height: ``,
}

Logo.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
}

export default Logo
